import { Injectable } from '@angular/core';
import { environment } from 'projects/shared/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class LinksService {
  URLApp = environment.apiUrl.replace(/api-/, "").replace(/api./, "").replace('v1', '').slice(0, -1) +'en/';
  // logo = '../../shop/src/assets/images/main/white 1.webp'
  facebook = 'https://www.facebook.com/Card4GamesLTD';
  instgram = 'https://www.instagram.com/card4games/';
  constructor() { }

}
